import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fullName } from '../../utils/helpers';
import FamilyMemberForm from '../members/FamilyMemberForm';

// Phone Families — one card per household: the whole head line is the tap
// target that opens it, the size sits in a badge, members are full-width rows
// with thumb-sized buttons, "+ Member" is a full-width button inside the card.
export default function FamiliesMobile({ vm }) {
  const {
    canView, canEdit, canDelete, loading, families, totals, rows, q, setQ,
    openFamily, setOpenFamily, addingTo, setAddingTo, addMember, removeMember, detachMember,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Families</h1></div>
        <div className="card card-pad empty">You do not have access to the guests of this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Families</h1>
        <span className="muted">{totals.families} · {totals.people} people</span>
      </div>
      <div className="gx-m-search-row">
        <input type="search" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />
        <Link className="btn primary" to="/app/members">+ Family</Link>
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : families.length === 0 ? (
          <div className="card card-pad empty">
            No families yet. On Guests tap “Add Family” — the head alone is enough, members can be added here later.
          </div>
        ) : families.map(fam => {
          const open = openFamily === fam.familyId;
          return (
            <div key={fam.familyId} className="card gx-m-fam">
              <div className="gx-m-fam-top">
                <button type="button" className="gx-m-fam-head" aria-expanded={open}
                  onClick={() => setOpenFamily(open ? null : fam.familyId)}>
                  <span className="gx-m-fam-main">
                    <span className="gx-m-fam-name">{open ? '▾ ' : '▸ '}{fam.headName}</span>
                    <span className="gx-m-fam-sub">{fam.head?.MobileNumber || 'no number'}</span>
                  </span>
                  <span className="gx-m-fam-size" title={`${fam.size} ${fam.size === 1 ? 'person' : 'people'}`}>{fam.size}</span>
                </button>
                {canEdit && fam.mine && (
                  <button type="button" className="btn light sm gx-m-fam-plus" onClick={() => setAddingTo(fam.head)}>+ Member</button>
                )}
              </div>

              {open && (
                <div className="gx-m-fam-body">
                  <div className="gx-m-fam-fns">
                    Invited to {fam.functionNames.join(', ') || '—'}
                  </div>
                  {fam.members.length === 0 ? (
                    <div className="muted" style={{ fontSize: 12.5 }}>
                      Only the head so far — one card, one name printed.
                    </div>
                  ) : fam.members.map(m => (
                    <div key={m.GuestId} className="gx-m-fam-member">
                      <div className="gx-m-fam-main">
                        <div>{fullName(m)}</div>
                        <div className="muted" style={{ fontSize: 12 }}>{m.MobileNumber || 'no number'}</div>
                      </div>
                      {canEdit && fam.mine && <button className="btn light sm" onClick={() => detachMember(m)}>Move out</button>}
                      {canDelete && fam.mine && <button className="btn danger sm" aria-label="Remove" onClick={() => removeMember(m)}>✕</button>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}

      {addingTo && (
        <FamilyMemberForm
          head={addingTo} rows={rows} functions={vm.functions}
          onClose={() => setAddingTo(null)}
          onSave={(payload) => addMember(addingTo, payload)}
        />
      )}
    </div>
  );
}
